import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const Rewards = loadable(() => import('./Rewards'), {
  fallback: <LoadingScreen />,
});

export default Rewards;
